import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";

/** Solo se guardan las filas con orden */
export const filaConOrden = (f) => f.orden !== "" && f.orden !== null && f.orden !== undefined;

const combo = ({ label, valor, onChange, lista, deshabilitado, requerido, asterisco, mensaje, md, ayuda }) => (
  <Form.Group as={Col} md={md}>
    <Form.Label>{label}{asterisco}</Form.Label>
    <Form.Select value={valor} onChange={(e) => onChange(e.target.value)} required={requerido} disabled={deshabilitado}>
      <option value="">[SELECCIONE]</option>
      {lista.map((o) => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </Form.Select>
    <Form.Control.Feedback type="invalid">{mensaje}</Form.Control.Feedback>
    {ayuda && <Form.Text muted>{ayuda}</Form.Text>}
  </Form.Group>
);

/**
 * Una fila de la seccion: serie, tipo documental y orden, con los botones redondos para
 * agregar o quitar filas. Una fila sin orden no se valida ni se guarda.
 * @param {object}   fila      {id, padre, serie, terna, orden}
 * @param {object}   listas    {series, tipos}
 * @param {object}   rango     {min, max, step} del orden, o null si el hijo no tiene padre con orden
 * @param {string}   padre     en hijos, "NOMBRE (orden N)" del padre con el que se numera
 * @param {function} onChange  (campo, valor) => void
 * @param {object}   acciones  {onAgregar, onQuitar, puedeQuitar}; null = fila fija (editar / ver)
 * @param {boolean}  soloLectura
 * @param {boolean}  oculta    no coincide con el buscador (se oculta, pero se sigue validando)
 * @param {boolean}  sinAsterisco  no marca los campos con * (otros documentos: el orden es opcional)
 */
const Filaordv = ({ fila, listas, rango, padre, onChange, acciones, soloLectura, oculta, sinAsterisco }) => {
  const requerido = filaConOrden(fila);
  const asterisco = requerido && !sinAsterisco ? "*" : "";
  const fija = !acciones;
  const sinPadre = Boolean(padre) && !rango;
  const mensajeOrden = rango ? `Entre ${rango.min} y ${rango.max}${rango.step > 1 ? `, de ${rango.step} en ${rango.step}` : ""}` : "";

  return (
    <Row className={`mt-2 align-items-start${oculta ? " d-none" : ""}`}>
      {combo({
        label: "Serie", valor: fila.serie, md: 4, mensaje: "Debe Seleccionar una Serie",
        onChange: (v) => onChange("serie", v), lista: listas.series, deshabilitado: fija, requerido, asterisco,
      })}
      {combo({
        label: "Tipo documental", valor: fila.terna, md: 5, mensaje: "Debe Seleccionar un Tipo documental",
        onChange: (v) => onChange("terna", v), lista: listas.tipos, deshabilitado: fija || !fila.serie, requerido, asterisco,
        ayuda: padre ? `Hijo de ${padre}` : "",
      })}
      <Form.Group as={Col} md={2}>
        <Form.Label>Orden{asterisco}</Form.Label>
        <Form.Control
          type="number"
          value={fila.orden}
          min={rango?.min}
          max={rango?.max}
          step={rango?.step}
          required={requerido}
          disabled={soloLectura || sinPadre}
          onChange={(e) => onChange("orden", e.target.value)}
        />
        <Form.Control.Feedback type="invalid">{mensajeOrden}</Form.Control.Feedback>
        {sinPadre && <Form.Text className="text-danger">Asigne primero el orden del padre</Form.Text>}
      </Form.Group>
      {acciones && (
        <Col md={1} className="d-flex align-items-center pt-4 mt-1">
          <Button
            variant="outline-primary"
            size="sm"
            className="ms-2 rounded-circle"
            onClick={acciones.onAgregar}
            style={{ width: "30px", height: "30px", color: "white", backgroundColor: "#007bff", border: "none" }}
          >
            +
          </Button>
          <Button
            variant="outline-secondary"
            size="sm"
            className="ms-2 rounded-circle bg-secondary text-white"
            onClick={acciones.onQuitar}
            disabled={!acciones.puedeQuitar}
            style={{ width: "30px", height: "30px", border: "none" }}
          >
            ×
          </Button>
        </Col>
      )}
    </Row>
  );
};

export default Filaordv;
